import { Abacus } from "Javascript/core/Abacus.Core";
import { Class } from "Javascript/core/Abacus.Utilities";
import moment from 'moment';

class TimeZoneFormat extends Class {

	constructor(element, options) {
		super();
		this.element = element;
		this.setOptions(options);

		this.locale = $('meta[name="momentlocale"]')[0].content;
		this.localeformat = $('meta[name="momentlocaleformat"]')[0].content;
		this.localenowdate = $('meta[name="momentnowdate"]')[0].content;
		this.localerelative = $('meta[name="momentrelative"]')[0].content;
		this.localerelativeformat = $('meta[name="momentrelativeformat"]')[0].content;
		this.localerelativemorethan = $('meta[name="momentrelativemorethan"]')[0].content;

		this.checkForDataAtt(this.element);

	}

	checkForDataAtt(element) {
		if (!$(element).data('dateTimezone')) {
			this.showDate();
		} else {
			this.setLocale();
			this.updateDate(this.element);
		}
	}

	setLocale() {
		moment.locale(this.locale);
	}

	updateDate(element) {
		let date = $(element).data('dateTimezone');
		let newdate = {
			publishdate: date.publishdate,
			format: date.format ? date.format : this.localeformat,
			nowdate: date.nowdate ? date.nowdate : this.localenowdate,
			relative: date.relative ? date.relative : this.localerelative,
			relativeFormat: date.relativeFormat ? date.relativeFormat : this.localerelativeformat,
			relativeMoreThan: date.relativeMoreThan ? date.relativeMoreThan : this.localerelativemorethan
		}

		// Would output date in past format e.g. 12 days go
		if (newdate.relative == 'true') {
			const start = moment(newdate.publishdate).format(newdate.relativeFormat),
				end = moment(newdate.now).format(newdate.relativeFormat),
				startf = moment(start.split(',')),
				endf = moment(end.split(','));

			const diffDays = endf.diff(startf, 'days');
			const dateRender = (diffDays > newdate.relativeMoreThan) ?
				moment.utc(newdate.publishdate).local().format(newdate.format) :
				endf.to(startf);

			$(this.element).text(dateRender);

		}
		// Would return standard format 24th February 2017
		else {
			$(this.element).text(moment.utc(newdate.publishdate).local().format(newdate.format));
		}
		this.showDate();
	}

	showDate() {
		$(this.element).addClass('visible');
	}

}

export { TimeZoneFormat };


// WEBPACK FOOTER //
// ./Javascript/core/classes/date.timezone.format.class.js